/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackAmplitudeEvent } from '@/helpers/facebookPixelEvents'

export default function ThankYou() {
  const navigate = useNavigate()
  const [appUrl, setAppUrl] = useState('https://cleanmaster.onelink.me/LtIi/5qbvkgkp')
  const email = localStorage.getItem('userEmail')

  const handleClick = () => {
    trackAmplitudeEvent('DownloadButtonClick')
    window.open(appUrl, 'blank')
  }

  useEffect(() => {
    if (!email) {
      navigate('/quiz/welcome')
    }
  }, [])

  return (
    <div className="thank-wr before:!hidden">
      <div>
        <h2 className="title">Download the app to continue</h2>
        <img
          className="block mx-auto"
          src="/quiz/icons/logo.png"
          alt="Logo"
          width={120}
          height={120}
        />
        <p className="description-thank-you text-center mt-4">Clean Master</p>
      </div>
      <button
        onClick={handleClick}
        className="text-center flex max-w-[343px] justify-center items-center w-full mt-3 h-14 py-2.5 px-4 rounded-4xl text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
        rel="noreferrer"
      >
        Download
      </button>
    </div>
  )
}
